"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OAuth2_1 = require("./OAuth2");
exports.OAuth2 = OAuth2_1.OAuth2;
//# sourceMappingURL=Main.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/dau-auth-library/dist/OAuthLib/Main.js
// module id = 396
// module chunks = 142